import OptionDetail from '../models/optionDetail';
import namespace from '../../upi/namespace';

var app = namespace( 'apps.productpage' );

var OptionDetailList = Backbone.Collection.extend( {

    model: OptionDetail,

    initialize: function ( models, options ) {
        this.listenTo( this, 'select:one', this.current );
        this.listenTo( this, 'clear:selected unselected', this.clearSelected );
        this.listenTo( this, 'selected', app.mediator.willTrigger( 'next:target' ) );

        this.clearSelected();
    },

    hasSelection: function () {
        return !!this._current;
    },

    clearSelected: function () {
        this.each( function ( model ) {
            model.set( 'selected', false );
        } );
        this.resetState();
    },

    resetState: function () {
        this.clearUnavailable();
        this.unsetCurrent();
    },

    toggleAvailableOptions: function ( availableOptionIds ) {
        this.each( function ( option ) {
            const optionId = option.get( 'id' );
            var isAvailable = availableOptionIds.indexOf( optionId ) !== -1;
            option.toggleAvailable( isAvailable );
        } );
    },

    toggleDisabledOptions: function ( disabledOptionIds ) {
        this.each( function ( option ) {
            var isDisabled = disabledOptionIds.indexOf( option.get( 'id' ) ) > -1;
            option.toggleDisabled( isDisabled );
        } );
    },

    clearUnavailable: function () {
        this.each( function ( option ) {
            option.toggleAvailable( true );
        } );
    },

    clearDisabled: function () {
        this.each( function ( option ) {
            option.toggleDisabled( false );
        } );
    },

    /**
     * Only allow a single option in collection to be selected at one time, resetting all items in collection
     * @param option
     * @returns {*}
     */
    current: function ( option ) {
        // getter/setter
        if ( option ) {
            this.clearSelected();
            option.set( {selected: true} );
            this._current = option;
            this.trigger( 'selected', option );
        }

        return this._current;
    },

    unsetCurrent: function () {
        this._current = null;
    },

    destroy: function () {
        this.stopListening( this );
    }

} );

export default OptionDetailList;
